import type { MessageSentEventData } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { ConversationTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import MessageIcon from "@redotech/redo-icons/message-chat-circle.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { formatSentenceCase } from "@redotech/util/string";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const MessageSentEvent = memo(function MessageSentEvent({
  event,
  data,
}: {
  event: ConversationTimelineEventResponse;
  data: MessageSentEventData;
}) {
  return (
    <Flex align="flex-start" className={styles.card} gap="sm">
      <Flex
        align="center"
        className={`${styles.icon} ${styles.iconIndigo}`}
        justify="center"
      >
        <MessageIcon />
      </Flex>
      <Flex className={styles.content} dir="column" gap="xxs">
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          Message sent via {formatSentenceCase(data.channel)}
        </Text>
        {data.preview && (
          <Text className={styles.details} fontSize="xxs" textColor="secondary">
            {data.preview}
          </Text>
        )}
        <EventTimestamp event={event} />
      </Flex>
    </Flex>
  );
});
